import { faker } from '@faker-js/faker'

import { getGroupedServiceOffer } from './GroupedServiceOfferView'
import { getServiceOffer } from './ServiceOffer'

import { HospitalCountry } from '../../contracts/hospital'
import { AdminServiceOfferDetails, Status, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getAdminServiceOfferDetails = asBuilder((): AdminServiceOfferDetails => {
  return {
    id: faker.number.int(),
    groupId: faker.string.uuid(),
    groupedServiceOffers: [getGroupedServiceOffer()],
    memo: faker.lorem.sentence(),
    metaTags: {
      image: {
        url: faker.image.url(),
      },
      title: faker.string.uuid(),
      description: faker.lorem.sentence(),
    },
    ad: {
      adDeductionPoint: faker.number.int(),
    },
    statusChangedHistories: faker.helpers.multiple(() => ({
      changedAtUtc: '2023-01-01T00:00:00Z',
      status: faker.helpers.enumValue(Status),
      description: faker.lorem.sentence(),
    })),
    hospital: {
      id: faker.number.int(),
      name: faker.lorem.sentence(),
      temporaryUnavailable: faker.datatype.boolean(),
      consultableLanguages: Object.values(TargetLanguage),
      country: faker.helpers.enumValue(HospitalCountry),
    },
    status: faker.helpers.enumValue(Status),
    treatmentCategories: faker.helpers.multiple(() => ({
      treatmentCategoryId: faker.number.int(),
      name: faker.string.uuid(),
    })),
    rating: {
      totalRating: faker.number.float({ min: 0, max: 10, multipleOf: 0.1 }),
      ratingCount: faker.number.int(),
    },
    ...getServiceOffer(),
  }
})
